"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VisibilityIconWrapper = exports.TextArea = exports.ShadowText = exports.InputWrapper = exports.InputWithShadowText = exports.Input = exports.InlineInputWrapper = exports.InlineInput = exports.Field = exports.CharactersInfo = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _UnderlinedTextbox = _interopRequireDefault(require("../Layout/Form/UnderlinedTextbox"));
var _palette = require("../../styles/palette");
var _scUtils = require("../../utils/sc-utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var fieldHeight = 40;
var paddingTopBottom = 0;
var paddingRightLeft = 16;
var borderRadius = 4;
var Field = exports.Field = _styledComponents["default"].div.withConfig({
  displayName: "styles__Field",
  componentId: "sc-jpehpb-0"
})(["margin-bottom:0px;", " &.tag-selection{max-height:60px;}&.tag-default-language{margin-top:-80px;}&.short{margin-bottom:-10px;}&.tall{margin-bottom:10px;}", ";", " ", " input:-webkit-autofill,input:-webkit-autofill:hover,input:-webkit-autofill:focus,input:-webkit-autofill:active{-webkit-box-shadow:0 0 0 30px white inset !important;}", " ", " ", ""], function (p) {
  return !p.inline && 'width: 100%;';
}, function (p) {
  return (0, _scUtils.cond)(p.size, "width: ".concat((0, _scUtils.oneOf)(p.size, {
    xxsmall: '80px',
    xsmall: '100px',
    small: '380px',
    large: '581px'
  }), "\n  "));
}, function (p) {
  return (p.size === 'xsmall' || p.size === 'xxsmall') && "\n    margin: 10px;\n    height: 40px;\n    vertical-align: top;\n    opacity: 1;\n  ";
}, function (p) {
  return p.inline && "\n    ".concat(p.editMode && "\n      border-bottom: 1px solid ".concat(_palette.commonPalette.txBlack, ";\n      color: ").concat(_palette.commonPalette.txGrey, ";\n\n      input {\n        color: ").concat(_palette.commonPalette.txGrey, ";\n      }\n    "), "\n    width: fit-content;\n    display: table;\n    cursor: ").concat(p.editMode ? 'default' : 'text', ";\n  ");
}, function (_ref) {
  var display = _ref.display;
  return display && "display: ".concat(display, ";");
}, function (_ref2) {
  var withPasswordValidation = _ref2.withPasswordValidation;
  return withPasswordValidation && 'margin-bottom: 5px;';
}, function (_ref3) {
  var hideArrows = _ref3.hideArrows;
  return hideArrows && 'input[type="number"]::-webkit-inner-spin-button, input[type="number"]::-webkit-outer-spin-button { -webkit-appearance: none; margin: 0; }';
});
var inputStyles = (0, _styledComponents.css)(["padding:", "px ", "px;height:", "px;border-radius:", "px;width:100%;color:", ";border:1px solid ", ";font-size:14px;outline:none;resize:none;&:focus{outline:none;border:", ";}", ";"], paddingTopBottom, paddingRightLeft, fieldHeight, borderRadius, _palette.commonPalette.txBlack, _palette.commonPalette.borderGrey, function (p) {
  return !p.inline && "1px solid ".concat(_palette.commonPalette.sgGreen, ";");
}, (0, _scUtils.placeholder)("\n    font-size: 14px;\n    color: ".concat(_palette.commonPalette.txLightGrey, ";\n  ")));
var ShadowText = exports.ShadowText = _styledComponents["default"].h4.withConfig({
  displayName: "styles__ShadowText",
  componentId: "sc-jpehpb-1"
})(["color:", ";line-height:0;"], _palette.commonPalette.txLightGrey);
var InputWithShadowText = exports.InputWithShadowText = _styledComponents["default"].div.withConfig({
  displayName: "styles__InputWithShadowText",
  componentId: "sc-jpehpb-2"
})(["", " ", ";display:flex;align-items:center;", ""], inputStyles, function (p) {
  return p.styles;
}, function (p) {
  return p.focus && "\n    border: 1px solid ".concat(_palette.commonPalette.sgGreen, ";\n  ");
});
var Input = exports.Input = _styledComponents["default"].input.withConfig({
  displayName: "styles__Input",
  componentId: "sc-jpehpb-3"
})(["", " ", ";", ";&:disabled{color:", ";}", ""], inputStyles, function (p) {
  return p.styles;
}, function (_ref4) {
  var width = _ref4.width;
  return width && "width: ".concat(width, "px");
}, _palette.commonPalette.txLightGrey, function (_ref5) {
  var withPasswordValidation = _ref5.withPasswordValidation;
  return withPasswordValidation ? 'padding-right: 40px;' : '';
});
var VisibilityIconWrapper = exports.VisibilityIconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__VisibilityIconWrapper",
  componentId: "sc-jpehpb-4"
})(["position:absolute;top:0;right:0;height:40px;justify-content:center;display:flex;align-items:center;cursor:pointer;margin:0 10px;color:#757575;"]);
var InputWrapper = exports.InputWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__InputWrapper",
  componentId: "sc-jpehpb-5"
})(["position:relative;"]);
var TextArea = exports.TextArea = _styledComponents["default"].textarea.withConfig({
  displayName: "styles__TextArea",
  componentId: "sc-jpehpb-6"
})(["", " ", ";"], inputStyles, function (p) {
  return p.styles;
});
var InlineInput = exports.InlineInput = (0, _styledComponents["default"])(_UnderlinedTextbox["default"]).withConfig({
  displayName: "styles__InlineInput",
  componentId: "sc-jpehpb-7"
})(["border:none;max-width:600px;cursor:", ";&::after{content:'  ';}"], function (p) {
  return p.readOnly ? 'default' : 'text';
});
var InlineInputWrapper = exports.InlineInputWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__InlineInputWrapper",
  componentId: "sc-jpehpb-8"
})(["display:flex;align-items:center;> svg{margin-left:20px;cursor:pointer;:hover{color:", ";}}"], _palette.commonPalette.sgGreen);
var CharactersInfo = exports.CharactersInfo = _styledComponents["default"].div.withConfig({
  displayName: "styles__CharactersInfo",
  componentId: "sc-jpehpb-9"
})(["position:absolute;bottom:10px;right:10px;color:", ";"], _palette.commonPalette.textSecondary);
//# sourceMappingURL=styles.js.map